import { ReactNode } from 'react'
import { FeatureFlags, FeatureFlagsContext } from './FeatureFlagsContext'

export function FeatureFlagsProvider({
  featureFlags,
  children,
}: {
  featureFlags: FeatureFlags | null | undefined
  children: ReactNode
}) {
  return (
    <FeatureFlagsContext.Provider value={featureFlags ?? null}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
